<div *ngIf="breadcrumbsService.breadcrumbs" fxLayout='row'>
    <a (click)="this.breadcrumbsService.go(breadcrumb)" [fxShow.xs]="last" fxShow="true"
        *ngFor="let breadcrumb of breadcrumbsService.breadcrumbs; index as i; let last = last">
        {{ getLabel(breadcrumb, i) | translate }}&nbsp;
    </a>
</div>